import { render, staticRenderFns } from "./Dashboardshippop.vue?vue&type=template&id=1787a275&"
import script from "./Dashboardshippop.vue?vue&type=script&lang=js&"
export * from "./Dashboardshippop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports